import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
  TemplateLibraryContextType,
  TemplateLibraryContext,
} from '../TemplateLibrary/TemplateLibrary.context';
import WorkStreamSelect from '@/pages/Dashboard/components/WorkstreamSelect/WorkstreamSelect.component';
import './TemplateLibraryModalFooter.scss';

const TemplateLibraryModalFooter = () => {
  const {
    importSelectedTemplates,
    loading,
    selectedWorkStreamId,
    handleWorkStreamChanged,
    templateLibraries = [],
    selectedFiles = [],
  } = useContext(TemplateLibraryContext) as TemplateLibraryContextType;
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="template-library-modal-footer">
      <div className="template-library-modal-footer__left">
        <span>{t('general.import_to')}</span>
        <WorkStreamSelect
          selectedId={id ?? ''}
          style={{ width: 200 }}
          onChange={handleWorkStreamChanged}
        />
        <span>
          {templateLibraries &&
          templateLibraries.filter(i => i.check).length > 0 ? (
            selectedWorkStreamId === null ? (
              'Please select a target workstream'
            ) : (
              <>
                {t('playbook.import_templates_info', {
                  name: selectedWorkStreamId?.name,
                  count: templateLibraries.filter(i => i.check).length,
                })}
              </>
            )
          ) : (
            selectedFiles &&
            selectedFiles.length > 0 &&
            (selectedWorkStreamId === null ? (
              'Please select a target workstream'
            ) : (
              <>
                {t('playbook.import_templates_info', {
                  name: selectedWorkStreamId?.name,
                  count: selectedFiles.length,
                })}
              </>
            ))
          )}
        </span>
      </div>
      <button
        className="template-library-modal-footer__button dark"
        onClick={importSelectedTemplates}
        disabled={
          !(
            selectedWorkStreamId !== null &&
            (templateLibraries.filter(i => i.check).length > 0 ||
              selectedFiles.length > 0)
          )
        }
      >
        {t('general.import_selected')}
      </button>
    </div>
  );
};

export default TemplateLibraryModalFooter;
